"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _text = require("@mmc/text");
var _specialOffer = _interopRequireDefault(require("../styles/special-offer.css"));
var _div;
var SpecialOffer = function SpecialOffer(_ref) {
  var theme = _ref.theme,
    label = _ref.label,
    disclaimerData = _ref.disclaimerData;
  if (label && label !== ' ') {
    return /*#__PURE__*/_react["default"].createElement(_text.Text, {
      text: label,
      className: theme.mmcBold + " " + _specialOffer["default"].specialOffer,
      tag: "label",
      disclaimerData: disclaimerData
    });
  }
  return _div || (_div = /*#__PURE__*/_react["default"].createElement("div", null));
};
SpecialOffer.displayName = 'SpecialOffer';
SpecialOffer.defaultProps = {
  theme: {}
};
var _default = SpecialOffer;
exports["default"] = _default;